<div class="emds ap-thread-message tile" id="{{Id}}" [apColorBorder]="borderColor" [borderDirection]="borderDirection">
  <div class="row header"> <!--header for collpase-->
    <div class="col-xs-12" id="{{Id}}-from">
      <label class="strong" translate>From:</label> {{message.From}} - {{message.SendDateTime | date:'M/d/yyyy h:mm a'}}
      <div class="clickable pull-right"
               id="{{Id}}-collapse-chevron"
               (click)="isCollapsed = !isCollapsed"
               [attr.aria-expanded]="!isCollapsed"
               aria-controls="thread-message-collapse">
        <i class="material-icons">{{(isCollapsed) ? 'expand_more' : 'expand_less'}}</i>
      </div>
    </div>
    <div class="col-xs-12" id="{{Id}}-patient">
      <label class="strong" translate>Patient:</label> {{message.Patient}}
    </div>
  </div>
  <div class="row" [collapse]="isCollapsed" [isAnimated]="true"> <!--collapsable-->
    <div class="col-xs-12 header" id="{{Id}}-subject-body">
      <label class="strong">{{message.Subject}}:</label>&nbsp;<label [innerHTML]="message.Body | safeHtml"></label>
    </div>
    <div class="col-xs-12">
      <hr>
    </div>
    <div class="col-xs-12 body">
      <div class="row">
        <div class="col-xs-6" id="{{Id}}-practice-provider"><label class="strong" translate>Practice Provider:</label> {{message.PracticeProvider}}</div>
        <div class="col-xs-6" id="{{Id}}-urgency"><label class="strong" translate>Urgency:</label> {{message.Urgency}}</div>
      </div>
      <div class="row">
        <div class="col-xs-6" id="{{Id}}-assigned"><label class="strong" translate>Assigned:</label> {{message.Assigned}}</div>
        <div class="col-xs-6" id="{{Id}}-service-site"><label class="strong" translate>Service Site:</label> {{message.ServiceSite}}</div>
      </div>
      <div class="row">
        <div class="col-xs-6" id="{{Id}}-subtype"><label class="strong" translate>Subtype:</label> {{message.Subtype}}</div>
        <div class="col-xs-6" id="{{Id}}-program"><label class="strong" translate>Program:</label> {{message.Program}}</div>
      </div>
      <div class="row">
        <div class="col-xs-6" id="{{Id}}-practice-provider"></div>
      </div>
    </div>
  </div>
</div>
